<template>
    <svg
        id="icon_lobby_name"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
    >
        <path
            id="Path_3"
            data-name="Path 3"
            d="M12,24A12,12,0,1,1,24,12,12,12,0,0,1,12,24ZM12,2.823a4.941,4.941,0,1,0,4.941,4.941A4.941,4.941,0,0,0,12,2.823Zm7.058,14.118a3.529,3.529,0,0,0-3.528-3.529H8.471a3.53,3.53,0,0,0-3.529,3.529v2.935a10.543,10.543,0,0,0,14.117,0Z"
            fill="#fff"
            fill-rule="evenodd"
        />
    </svg>
</template>
